// React
import { useState, useEffect } from 'react';

// utilities
import { useSearchAndFilterStore } from 'utilities/store';

const useSearchAndFilter = ({ instanceName }) => {
    // ///////////////////
    // STORES
    // ///////////////////

    const {
        createInstance,
        getInstance,
        setInitial: setInitialStore,
        setFiltered: setFilteredStore,
        setFilter: setFilterStore,
        setSelected: setSelectedStore,
        reset: resetStore,
    } = useSearchAndFilterStore();

    // ///////////////////
    // STATE
    // ///////////////////

    // ///////////////////
    // METHODS
    // ///////////////////

    function setInitial(initial) {
        setInitialStore(instanceName, initial);
    }

    function setFiltered(filtered) {
        setFilteredStore(instanceName, filtered);
    }

    function setFilter(filter) {
        setFilterStore(instanceName, filter);
    }

    function setSelected(selected) {
        setSelectedStore(instanceName, selected);
    }

    function reset() {
        resetStore(instanceName);
    }

    // ///////////////////
    // EFFECTS
    // ///////////////////

    useEffect(() => {
        createInstance(instanceName);
    }, [instanceName]);

    // ///////////////////
    // RETURN
    // ///////////////////

    return {
        initial: getInstance(instanceName)?.initial,
        filtered: getInstance(instanceName)?.filtered,
        filter: getInstance(instanceName)?.filter,
        selected: getInstance(instanceName)?.selected || [],
        setInitial,
        setFiltered,
        setFilter,
        setSelected,
        reset,
    };
};

export default useSearchAndFilter;
